import { Backend } from '@/_axios';

export default {
  user() {
    return Backend.get('/api/users/me');
  },
  userWithProject() {
    return Backend.get('/api/auth/user_data');
  },
  // Refresh token
  refresh(token) {
    return Backend.get('/api/auth/refresh', { tokenOverride: token });
  },
  login(data) {
    return Backend.post('/api/auth/login', data, { public: true });
  },
  oAuthLogin(data) {
    return Backend.post('/api/auth/oauth_login', data, { public: true });
  },
  tvLogin(data) {
    return Backend.post('/api/auth/tv_login', data, { public: true });
  },

  // register(data) {
  //   return Backend.post('auth/register', data);
  // },
  // forgotPassword(emailData) {
  //   return Backend.post('auth/forgot-password', emailData);
  // },
  // resetPassword(resetData) {
  //   return Backend.put('auth/reset-password', resetData);
  // },

  // getRefreshTokens() {
  //   return Backend.get('auth/refresh_tokens');
  // },
  // deleteRefreshToken(tokenId) {
  //   return Backend.delete(`auth/refresh_tokens/${tokenId}`);
  // },
  // createApiToken(name) {
  //   return Backend.put('auth/api_tokens/create', { name: name });
  // },
};
